export default {"src":"/_next/static/media/back-gray.c4735363.svg","height":24,"width":24};